import is from '@sindresorhus/is';
import clsx from 'clsx';
import type { FunctionComponent } from 'react';

import { Breadcrumbs } from '~/ui/core/breadcrumbs/Breadcrumbs';

export const Breadcrumb: FunctionComponent<{
    readonly className?: string;
    readonly parts: readonly (string | undefined)[];
}> = ({ className, parts }) => (
    <Breadcrumbs
        className={clsx('max-w-full overflow-hidden [&>div]:min-w-0 [&_svg]:shrink-0', className)}
        items={parts.filter(is.nonEmptyString).map((label) => ({ label }))}
        labelClassName="truncate text-inherit"
        lastItemIsCurrent={false}
    />
);
